<div class="customer-details-card">
  <div class="">
    <div class="col-lg-12 p-0">
      <app-card cardTitle="{{ 'confirm' | translate }}" headerClass="confirmTitle" [padding]="20">
        <ng-template #headerOptionsTemplate>
          <a href="javascript:" class="text-muted" mat-dialog-close>
            <i class="ti ti-x f-20"></i>
          </a>
        </ng-template>
        <div class="personal-details">
          <div class="row">
            <div class="col-md-12">
              <h3 class="text-muted flex justify-content-center"> {{ message | translate }} </h3>
            </div>
            <div class="col-md-12">
              <div class="flex justify-content-center">
                <button mat-flat-button color="primary m-15" (click)="cancel()">
                  <div> {{ 'cancel' | translate }} </div>
                </button>

                <button mat-flat-button color="warn m-15" (click)="confirm()">
                  <div> {{ 'confirm' | translate }} </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </app-card>
    </div>
  </div>
</div>
